module.exports = __webpack_public_path__ + "static/media/family_10.eb2c3a37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_10.jpg
// module id = 5842
// module chunks = 0